/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum TimeFormat {
    TWENTY_FOUR_HOUR = 'twentyFourHour',
    TWELVE_HOUR = 'twelveHour'
}


export function instanceOfTimeFormat(value: any): boolean {
    for (const key in TimeFormat) {
        if (Object.prototype.hasOwnProperty.call(TimeFormat, key)) {
            if (TimeFormat[key as keyof typeof TimeFormat] === value) {
                return true;
            }
        }
    }
    return false;
}

export function TimeFormatFromJSON(json: any): TimeFormat {
    return TimeFormatFromJSONTyped(json, false);
}

export function TimeFormatFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeFormat {
    return json as TimeFormat;
}

export function TimeFormatToJSON(value?: TimeFormat | null): any {
    return value as any;
}

export function TimeFormatToJSONTyped(value: any, ignoreDiscriminator: boolean): TimeFormat {
    return value as TimeFormat;
}

